import { createDecorator } from "../../instantiation/common/registry.js";
import { Event } from "../../../base/common/events.js";
import { Disposable } from "../../../base/common/lifecycle.js";

export const ISecretStorageService = createDecorator<ISecretStorageService>('secretStorageService');

export interface ISecretStorageProvider {
    type: 'in-memory' | 'persisted' | 'unknown';
    get(key: string): Promise<string | undefined>;
    set(key: string, value: string): Promise<void>;
    delete(key: string): Promise<void>;
    keys?(): Promise<string[]>;
}

export interface ISecretStorageService extends ISecretStorageProvider {
    readonly _serviceBrand: undefined;
    readonly onDidChangeSecret: Event<string>;
}


export class MemoryStorageService extends Disposable implements ISecretStorageProvider {
    readonly type: "in-memory";

    private readonly storage: Map<string, string> = new Map();

    get(key: string): Promise<string | undefined> {

        return Promise.resolve(this.storage.get(key));
    }

    async set(key: string, value: string): Promise<void> {

        this.storage.set(key, value);
    }

    async delete(key: string): Promise<void> {

        this.storage.delete(key);
    }
    
    async keys?(): Promise<string[]> {

        return Array.from(this.storage.keys());
        
    }

}


